import React from "react";

interface IMissingItem {
  missingFields: string[];
  handleEdit: () => void;
}

const MissingInfoFC = (props: IMissingItem) => {
  const { missingFields, handleEdit } = props;
  return (
    <>
      <h4>
        The following information is required in order to move this Lead to
        Contacting:
      </h4>
      <div className="missing-container">
        {missingFields.map((item: string) => (
          <div key={item}>{item}</div>
        ))}
      </div>
      <button className="editLeadInfoBtn" type="button" onClick={handleEdit}>
        Edit Lead Info
      </button>
    </>
  );
};

export default MissingInfoFC;
